import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    return network.post(`admin/bo/forgotPassword`, params).then(() => {
        return true;
    });
};

export const useMutationForgotPassword = () => {
    return useMutation<unknown, QueryError, { email: string }>({ mutationFn });
};
